import type { InputHTMLAttributes } from "react";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  hint?: string;
  error?: string;
};

export function Input({ label, hint, error, className = "", ...rest }: Props) {
  return (
    <label className="block">
      {label && (
        <div className="text-[13px] font-semibold text-ink-500 uppercase tracking-wider mb-2">
          {label}
        </div>
      )}
      <input
        className={`
          w-full h-13 px-4 text-base
          bg-ink-50 border border-ink-200
          rounded-[var(--radius-md)]
          text-ink-900 placeholder:text-ink-400
          focus:outline-none focus:border-brand-purple focus:bg-surface
          focus:ring-4 focus:ring-brand-purple/10
          transition-all duration-150
          ${error ? "border-brand-red focus:border-brand-red focus:ring-brand-red/10" : ""}
          ${className}
        `}
        {...rest}
      />
      {(hint || error) && (
        <div className={`text-[13px] mt-2 ${error ? "text-brand-red font-medium" : "text-ink-500"}`}>
          {error ?? hint}
        </div>
      )}
    </label>
  );
}
